<template>
  <article>
    <section id="home-two">
      <div class="wrapper">
        <div class="subhead fill">
          <span>产品优势</span>
        </div>
        <div class="p1-box">
          <div class="pure-g">
            <div style="line-height: 30px;" class="pure-u-1 pure-u-xl-1-1" v-if="superiorityListContant[0].content">
              <p v-html="superiorityListContant[0].content"></p>
            </div>
          </div>
        </div>
        <div class="p0-box">
          <div class="pure-u-1 pure-u-xl-1-1">
            <div class="history">
              <div class="history-box" v-for="(item, index) in superiorityListImg" :key="index">
                <img :src="'https://himifi.cn/api/admin/getImage?path=' + item.imageUrl" oncontextmenu="return false;" />
              </div>
            </div>
          </div>
        </div>
        <div id="videoContant">
          <video controls muted loop style="width: 100%;margin-top: 20px;">
            <source src="https://himifi-soft-1.oss-cn-wulanchabu.aliyuncs.com/commercialVideo/7d5cf0f2f4979e07b9000430be605f47.mp4" type="video/mp4">
          </video>
        </div>
      </div>
    </section>
    <section class="products">
      <div class="wrapper">
        <section id="top-company">
          <div class="wrapper">
            <div class="subhead fill">
              <span>五大关键技术</span>
            </div>
            <div ref="mySwiper" v-swiper:mySwiper="swiperOption" class="swiper-container">
              <div class="swiper-wrapper" style="margin-top: 20px;">
                <div class="swiper-slide" v-for="(item, index) in swiperList" :key="index">
                  <img :src="'https://himifi.cn/api/admin/getImage?path=' + item.imageUrl" oncontextmenu="return false;">
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  </article>
</template>

<script>
export default {
  name: "Product",
  data() {
    return {
      superiorityListImg: [],
      superiorityListContant: [],
      // 轮播图
      swiperList: [],
      curLunbo: 1,
      swiperOption: {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        // loop: true,
        breakpoints: {
          768: {  //当屏幕宽度大于等于768 
            slidesPerView: 1,
            spaceBetween: 3
          },
          1280: {  //当屏幕宽度大于等于1280
            slidesPerView: 1,
            spaceBetween: 3
          },
          1440: {  //当屏幕宽度大于等于1440
            slidesPerView: 1,
            spaceBetween: 3
          },
          1920: {  //当屏幕宽度大于等于1920
            slidesPerView: 1,
            spaceBetween: 3
          }
        }
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  created() {
    // 产品优势
    this.superiority()
  },
  methods: {
    // 产品优势
    superiority() {
      this.$http.get("/website/hnWebsiteContentInfo/getList", {
        firstType: "3"
      }, res => {
        if (res.code == '200') {
          this.superiorityListImg = res.data.产品优势[1]
          this.superiorityListContant = res.data.产品优势[3]
          this.swiperList = res.data.五大关键技术[1]
          setInterval(() => {
            this.curLunbo += 1
            if (this.curLunbo >= this.swiperList.length) {
              this.curLunbo = 0
            }
            this.swiper.slideTo(this.curLunbo, 2000, false)
          }, 3000)
        }
      })
    }
  }
}
</script>

<style scoped>
@import "~@/assets/styles/product.css";

.history {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.history-box {
  text-align: center;
  padding-bottom: 20px;
}

.history-box>img {
  width: 385px;
}
</style>
